import { Enrolment } from './enrolment';
export class Student {
    firstname:string=""
    lastname:string=""
    fullname:string=""
    pindingQuizCount:number=0
    doneQuizCount: number=0
    enrolments=[] 
    gifts=[]
    pendingQuizEnvelops=[]
    doneQuizEnvelops=[]
    allQuizCount:number=0
    server_user_id=0
    server_guardian_user_id=0
    server_student_id=0
    server_guardian_id=0
    maxGuardianTrialAnswerSubmit=0
    isGiftReady=false
    giftPassCounterPercent=0
    giftPassCount=0
    isOnTrial=false
    currentEnrolment:Enrolment=new Enrolment()
    is_premium_ready=0
    countryname=""

}
